import Multiselect from "multiselect-react-dropdown";
import styles from "./styles.module.scss";
import { AnalysisLstatLogsGraphInterface } from "../../../interfaces/fe.interfaces";

export interface AnalysisLstatMultiselectProps {
  graphs: AnalysisLstatLogsGraphInterface[]
  handleOnSelect: (selectedGraphs: AnalysisLstatLogsGraphInterface[], selectedGraph: AnalysisLstatLogsGraphInterface) => void
  handleOnRemove: (selectedGraphs: AnalysisLstatLogsGraphInterface[], removedGraph: AnalysisLstatLogsGraphInterface) => void
}

const AnalysisLstatMultiselect = ({
  graphs,
  handleOnSelect,
  handleOnRemove
}: AnalysisLstatMultiselectProps) => {
  return <div className={styles.analysisLstatMultiselectContainer}>
    <Multiselect
      disable={!graphs.length}
      displayValue="graph_file_name"
      onSelect={handleOnSelect}
      onRemove={handleOnRemove}
      options={graphs}
    />
  </div>;
};

export default AnalysisLstatMultiselect;